<template>
  <pl-dialog
    title="Sync Assessment"
    :size="'sm'"
    :disableOutsideClick="true"
    @close="$emit('close')"
  >
    <div class="flex justify-center my-24" v-if="isLoading === true">
      <pl-spinner class="w-12 h-12" />
    </div>
    <div
      v-if="
        !integrationToSyncAssessment &&
        isLoading === false &&
        currentActivity.google_classroom_course_work_id === null
      "
      class="py-5 flex-grow overflow-y-auto my-4"
    >
      <div class="flex justify-center mb-4">
        <div
          class="bg-gray-100 p-4 rounded-full border border-solid border-gray-200"
        >
          <i class="fa-solid fa-chalkboard-user text-primary text-2xl"></i>
        </div>
      </div>
      <h6 class="text-center text-gray-700 text-lg font-semibold mb-3">
        Would you like to sync grades?
      </h6>
      <div class="px-28 mb-12 text-center">
        <span class="text-center text-gray-700">
          Heads up, you must connect this
          <span class="font-semibold">Parlay Course</span> to a class in your
          LMS, and then connect this
          <span class="font-semibold"
            >RoundTable to an assignment in your LMS</span
          >
          before you can sync assessment data between the two systems.
        </span>
      </div>
    </div>
    <div v-else>
      <div v-if="currentActivity.google_classroom_course_work_id">
        <IntegrationCard
          :title="'Google Classroom'"
          :icon="'/static/google_class_round.png'"
          :code="'google-classroom'"
          :sync="true"
          :memberships="memberships"
        />
      </div>
      <!-- <div v-if="integrationToSyncAssessment">
        <IntegrationCard
          :title="integrationToSyncAssessment.name"
          :icon="'/static/integrations/schoology.png'"
          :code="integrationToSyncAssessment.name.toLowerCase()"
          :sync="true"
          :memberships="memberships"
        />
      </div> -->
    </div>
    <div
      v-if="
        !integrationToSyncAssessment &&
        isLoading === false &&
        currentActivity.google_classroom_course_work_id === null
      "
      class="flex center justify-center my-7"
    >
      <button
        v-if="
          getCourseDetail.edlink_integrations.length === 0 &&
          getCourseDetail.google_classroom_integration.course_id === undefined
        "
        @click="pushToCourseIntegrations"
        class="bg-primary text-white px-6 py-2 rounded"
      >
        Connect Course
      </button>
      <button
        @click="$emit('goToInviteStudents'), $emit('close')"
        class="bg-primary text-white px-6 py-2 rounded"
        v-else
      >
        Connect RoundTable
      </button>
    </div>
  </pl-dialog>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import IntegrationCard from 'features/courses/components/integrationCard.vue';
  import getBillingInformation from 'services/account/getBillingInformation';

  export default Vue.extend({
    components: {
      IntegrationCard,
    },
    data() {
      return {
        isLoading: false,
        memberships: {},
      };
    },
    computed: {
      ...mapGetters([
        'getCourseDetail',
        'getCurrentRT',
        'getCurrentDiscussion',
        'getProviders',
      ]),
      currentActivity() {
        return this.$route.params.roundtableID
          ? this.getCurrentRT
          : this.getCurrentDiscussion;
      },
      integrationToSyncAssessment() {
        if (
          this.getProviders &&
          this.currentActivity.edlink_integrations.length > 0
        ) {
          const { id } = this.currentActivity.edlink_integrations[0];
          const provider = this.getProviders.find(
            (p) => p.integration_id === id
          );
          if (provider) {
            return provider;
          }
          return false;
        }
        return false;
      },
    },
    methods: {
      providers() {
        this.isLoading = true;
        const courseID = this.$route.params.courseID;
        this.$store
          .dispatch('getSsoProviders', courseID)
          .then(() => {
            this.isLoading = false;
          })
          .catch((err) => {
            console.error(err);
          });
      },
      pushToCourseIntegrations: function () {
        this.$router.push({ name: 'course.settings.integrations' });
      },
    },
    created() {
      getBillingInformation().then((res) => {
        const { memberships } = res.data;
        this.memberships = memberships;
      });
    },
    mounted() {
      if (this.getProviders && this.getProviders.length) {
        return;
      } else {
        this.providers();
      }
    },
  });
</script>



// WEBPACK FOOTER //
// connectIntegrationsAssessmentModal.vue?d3c1cc98